import {compressImageFile, openFile} from "@mytour/platform";
import {Splitter} from "@mytour/ui/layout";
import {toast} from "react-toastify";
import {Button, FormGroup, Label} from "reactstrap";

type Props = {
  logoSquareThumbnail: string | undefined;
  logoContentType: string | undefined;
  onLogoChange: (
    contentType: string,
    base64Data: string,
    horizontalThumbnailBase64: string,
    squareThumbnailBase64: string
  ) => void;
  onLogoClear: () => void;
  disabled: boolean;
  label: string;
};

export function LogoPicker({
  logoSquareThumbnail,
  logoContentType,
  onLogoChange,
  onLogoClear,
  disabled,
  label,
}: Props) {
  return (
    <FormGroup>
      <Label>{label}</Label>
      <br />
      {logoSquareThumbnail ? (
        <Splitter width1={58} width2={40}>
          <div style={{textAlign: "center"}}>
            <a onClick={() => logoContentType && openFile(logoContentType, logoSquareThumbnail)}>
              <img
                src={`data:${logoContentType};base64,${logoSquareThumbnail}`}
                style={{maxHeight: "100px", maxWidth: "100%"}}
                alt="Logo"
              />
            </a>
          </div>

          <div style={{marginTop: "10px", textAlign: "left"}}>
            <Button color="danger" onClick={onLogoClear}>
              Supprimer
            </Button>
          </div>
        </Splitter>
      ) : (
        <input type="file" onChange={handleFileChange} accept="image/*" disabled={disabled} />
      )}
    </FormGroup>
  );

  async function handleFileChange(event: React.ChangeEvent<HTMLInputElement>) {
    const file = event.target.files?.[0];
    if (!file) {
      return;
    }
    try {
      const {contentType, base64Data, horizontalThumbnailBase64, squareThumbnailBase64} =
        await compressImageFile(file);
      onLogoChange(contentType, base64Data, horizontalThumbnailBase64, squareThumbnailBase64);
    } catch {
      toast.error("Impossible de lire l'image");
    }
  }
}
